import { render, staticRenderFns } from "./List.vue?vue&type=template&id=4ed1d0c0&scoped=true&"
import script from "./List.vue?vue&type=script&lang=js&"
export * from "./List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed1d0c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4ed1d0c0', component.options)
    } else {
      api.reload('4ed1d0c0', component.options)
    }
    module.hot.accept("./List.vue?vue&type=template&id=4ed1d0c0&scoped=true&", function () {
      api.rerender('4ed1d0c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/users/List.vue"
export default component.exports